import React, {useEffect} from 'react'
import {Stack} from '@mui/material'
import WbOutlineButton from '../../../components/common/WbOutlineButton'
import ChangeCheckInQuestion from './ChangeCheckInQuestion'
import {Emoji} from 'emoji-picker-react'

export default function CheckInQuestion({
  canChange,
  checkInQuestion,
  setCheckInQuestion,
}) {
  const [openChange, setOpenChange] = React.useState(false)

  return (
    <div className="checkin-question-block">
      <Stack
        direction="column"
        mt={2}
        mb={3}
        justifyContent="center"
        alignItems="center"
      >
        <div className="checkin-question-item">{checkInQuestion?.question}</div>
        <div className="answers">
          {checkInQuestion.options.map((option, index) => (
            <div key={index} className="answer-item">
              <span>
                <Emoji unified={option?.emoji} size={64} />
              </span>
              {option?.label}
            </div>
          ))}
        </div>
      </Stack>
      <div className="edit-question">
        {openChange && (
          <ChangeCheckInQuestion
            onClose={() => setOpenChange(false)}
            checkInQuestion={checkInQuestion}
            setCheckInQuestion={setCheckInQuestion}
          />
        )}
        {canChange && (
          <WbOutlineButton
            CustomOutlineButtonText={'Edit Question'}
            onClick={e => setOpenChange(true)}
          />
        )}
      </div>
    </div>
  )
}
